import type { CarPlugType } from '@ahd/shared/types/ahd-cars/car/wltp';
import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntPlugTypes: SelectDataObject<{ i: CarPlugType }>[] = [
    { i: 'TYPE_1', t: 'Typ 1' },
    { i: 'TYPE_2', t: 'Typ 2' },
    { i: 'CCS_COMBO', t: 'Kombiniertes Ladesystem (CCS)' },
    { i: 'CHADEMO', t: 'CHAdeMO' },
    { i: 'SCHUKO', t: 'Schuko' },
    { i: 'TESLA_SC', t: 'Tesla Supercharger' },
];
export default sIntPlugTypes;
